/**
 * ==========================================================================
 * SCENTADDA SPLASH OVERLAY
 * Production Ready
 * ==========================================================================
 */



(() => {
  "use strict";

  const STORAGE_KEY = "sa_splash_seen";

  const splash = document.getElementById("SplashOverlay");

  if (!splash) return;

  // Theme editor me hamesha show hone do
  if (Shopify.designMode) return;

  const firstVisitOnly =
    splash.dataset.firstVisit === "true";

  /**
   * -------------------------------------------------
   * Lock Scroll
   * -------------------------------------------------
   */

  const lockScroll = () => {
    document.body.classList.add("sa-splash-active");
  };

  /**
   * -------------------------------------------------
   * Unlock Scroll
   * -------------------------------------------------
   */

  const unlockScroll = () => {
    document.body.classList.remove("sa-splash-active");
  };

  /**
   * -------------------------------------------------
   * Hide Splash
   * -------------------------------------------------
   */

  
  const hideSplash = () => {
    localStorage.setItem("sa_splash_seen","true");
document.documentElement.classList.add("sa-hide-splash");

    splash.classList.add("sa-splash--hidden");

    splash.setAttribute("aria-hidden", "true");

    unlockScroll();

    localStorage.setItem(STORAGE_KEY, "true");

    setTimeout(() => {

      splash.style.display = "none";

    }, 350);

  };

  /**
   * -------------------------------------------------
   * First Visit Check
   * -------------------------------------------------
   */

  if (
    firstVisitOnly &&
    localStorage.getItem(STORAGE_KEY) === "true"
  ) {

    splash.style.display = "none";

    unlockScroll();

    return;

  }

  lockScroll();

  /**
   * -------------------------------------------------
   * Enter Button
   * -------------------------------------------------
   */

  const enterButton =
    splash.querySelector(".sa-splash__button");

  if (enterButton) {

    enterButton.addEventListener("click", function (e) {

      e.preventDefault();

      hideSplash();

    });

  }

  document.querySelectorAll('.sa-splash__image').forEach(function(image) {
  image.addEventListener('click', function() {
    hideSplash(); // Agar ye function pehle se hai
  });
});

document.querySelectorAll('.sa-splash__image').forEach(function(image) {
  image.addEventListener('click', function() {
    document.querySelector('.sa-splash').classList.add('hide');
    localStorage.setItem('sa_splash_seen', 'true');
    document.body.style.overflow = '';
  });
});

  /**
   * -------------------------------------------------
   * Splash Links
   * -------------------------------------------------
   */

  splash.querySelectorAll("a").forEach(link => {

    link.addEventListener("click", () => {

      localStorage.setItem(STORAGE_KEY, "true");

    });

  });

  /**
   * -------------------------------------------------
   * Header Links
   * -------------------------------------------------
   */

  document.querySelectorAll(
    ".sa-menu a, .sa-mobile-menu a"
  ).forEach(link => {

    link.addEventListener("click", () => {

      localStorage.setItem(STORAGE_KEY, "true");

    });

  });

  /**
   * -------------------------------------------------
   * Escape Key
   * -------------------------------------------------
   */

  document.addEventListener("keydown", (e) => {

    if (e.key === "Escape") {

      hideSplash();

    }

  });

  /**
   * -------------------------------------------------
   * Browser Back
   * -------------------------------------------------
   */

  window.addEventListener("pageshow", () => {

    if (
      firstVisitOnly &&
      localStorage.getItem(STORAGE_KEY) === "true"
    ) {

      splash.style.display = "none";

      unlockScroll();

    }

  });

})();